module.exports = __webpack_public_path__ + "../resources/img/qr-android-go.65230397.png";